module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 12
// module chunks = 1